import styled from 'styled-components'
import { BHS_PRETO } from 'constants/cores'

export const Container = styled.div`
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 32px;
  }
`;

export const Header = styled.header`
    font-size: 18px;
    letter-spacing: 0px;
    color: #000;
    font-weight: bold;
`;

export const Content = styled.div`
  letter-spacing: 0px;
  color: #000;
  font-size: 14px;

  strong {
      font-weight: bold;
  }

  > strong {
      display: block;
      margin-top: 16px;
      margin-bottom: 4px;
  }

  ul {
      margin: 4px 0;
      padding-left: 20px;
  }

  p {
      margin: 8px 0;
  }
`;

export const Footer = styled.div`
    font-size: 18px;
    letter-spacing: 0px;
    color: ${BHS_PRETO};
    padding: 25px 0;

    .checked-Policy{
      margin-right: 10px;
    }
`;
